import {DomainEvent} from './DomainEvent';
import {Match} from '../resources/Match';

export class MatchCreated extends DomainEvent<Match> {}
